import React, { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import queryString from "query-string";
import styles from './first.module.scss';

import {
  Button,
  FormContainer,
  Form,
  Page,
  PageTitle,
  SelectBox,
  SelectInput,
  SelectInputOption,
  Spacer
} from "lantmannen-common-widget";

import Grid from "@material-ui/core/Grid";

import { cropActions, cropSelectors } from "state/crops";
import { weedActions } from "state/weeds";
import { strategyActions } from "state/strategies";

const FirstPage = ({
  clearWeeds,
  clearStrategies,
  ui,
  crops,
  weeds,
  changeSelectedSeason,
  changeSelectedCrop,
  history,
  location,
  seasons,
  requestCrops,
  requestWeeds,
  selectedCrop,
  selectedSeason,
  selectedCropValue,
  setSeasons,
  ...props
}) => {
  const searchQuery = queryString.parse(location.search);

  const containerData = document.getElementById('react-odla-ograsmedel').dataset.preselectedCrop;;

  function changeCrop(event) {
    changeSelectedCrop(parseInt(event.target.value));
  }

  function changeSeason(event) {
    changeSelectedSeason(parseInt(event.target.value));
  }

  useEffect(() => {
    requestCrops();

    if(searchQuery.crop) {     
      changeSelectedCrop(parseInt(searchQuery.crop));
    }
    else if (containerData) {
      changeSelectedCrop(parseInt(containerData));
    }
  }, [changeSelectedCrop, containerData, requestCrops, searchQuery.crop]);

  /* Check if a season exist within the selected crop */
  useEffect(() => {
    if (selectedCrop) {
      let seasons = selectedCrop.listOfSeasons ? selectedCrop.listOfSeasons : [];
      if (seasons.length < 1) {
        changeSelectedSeason(0);
      } else {
        changeSelectedSeason(selectedCrop.listOfSeasons[0].seasonID);
      }
    }
  }, [selectedCrop]);

  useEffect(() => {
    if (selectedCrop && selectedSeason > -1)
      requestWeeds(selectedCrop.value, selectedSeason);
  }, [selectedCrop, selectedSeason]);

  function onSubmit(event) {
    event.preventDefault();
    clearWeeds();
    history.push("/weeds?season=" + crops.selectedSeason + "&crop=" + crops.selectedCropValue);
  }
  
  function moveToStrategiesPage() {
    const selectedWeedIds = weeds.weeds.map(weed => weed.id).join();
    let stategiesUrl =
      "/strategies?season=" + crops.selectedSeason +
      "&crop=" + crops.selectedCropValue;
      
    clearStrategies();
    history.push(stategiesUrl);
  }

  return (
    <Page>
      <PageTitle title={"Välj gröda"}>
        <Spacer />
      </PageTitle>

      <Form onSubmit={onSubmit} id="select-crop-form">
        <FormContainer>
          <SelectBox title="Välj gröda">
            <SelectInput
              value={selectedCropValue}
              onChange={changeCrop}
              name="crop"
              data-testid="crop-input"
              >
              <SelectInputOption
                disabled
                key={-1}
                value={-1}
                name={"Välj gröda"}
              />
              {crops.allCrops.map((crop,i) => (
                <SelectInputOption
                  key={i}
                  value={crop.value}
                  name={crop.text}
                />
              ))}
            </SelectInput>
          </SelectBox>

          {selectedCrop && selectedCrop.listOfSeasons.length > 1 && (
            <SelectBox title="Välj säsong">
              <SelectInput
                value={selectedSeason}
                data-testid="season-input"
                onChange={changeSeason}
                name="season"
              >
                {selectedCrop.listOfSeasons.map(season => (
                  <SelectInputOption
                    key={season.seasonID}
                    value={season.seasonID}
                    name={season.seasonName}
                  />
                ))}
              </SelectInput>
            </SelectBox>
          )}
          <Spacer empty />
          <Grid container direction="row" spacing={1}>
            <Grid container item justifyContent="flex-end" xs={12} sm={7}> 
              <Button
                onClick={moveToStrategiesPage}
                disabled={!selectedCrop || ui.loading }
                text="Visa alla strategier"
                className={styles["button-secondary"]}
                data-testid="strategies-button"
              />
            </Grid>
            <Grid container item justify="flex-end" xs={12} sm={5}>
              <Button
                disabled={!selectedCrop}
                value="Submit"
                type="submit"
                form="select-crop-form"
                text="Välj ogräs"
                data-testid="crop-button"
              />
            </Grid>
          </Grid>
        </FormContainer>
      </Form>
    </Page>
  );
};

const mapStateToProps = state => ({
  ui: state.ui,
  crops: state.crops,
  weeds: state.weeds,
  selectedCrop: cropSelectors.selectedCrop(state),
  selectedCropValue:state.crops.selectedCropValue,
  selectedSeason:state.crops.selectedSeason
});

const mapDispatchToProps = dispatch => ({
  changeSelectedCrop: id => dispatch(cropActions.changeSelectedCrop(id)),
  changeSelectedSeason: id => dispatch(cropActions.changeSelectedSeason(id)),
  requestCrops: () => dispatch(cropActions.requestCrops()),
  requestWeeds: (cropId, seasonId) => dispatch(weedActions.requestWeeds(cropId, seasonId)),
  clearWeeds: () => dispatch(weedActions.clearWeeds()),
  clearStrategies: () => dispatch(strategyActions.clearStrategies())
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(FirstPage)
);
